import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import Popup from "@metacrm/metacrm-material-ui/dist/Popup";
import { Box } from "@mui/material";
import axios from "axios";
import { apiUrl } from "features/configure";
import { upperFirst } from "lodash";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useOutletContext } from "react-router";

export default function KbLinkModal({ onClose, type, onBack, refetch }) {
  const [entityName] = useOutletContext();
  const { formatMessage } = useIntl();
  const linkWording = {
    Link: {
      api: "website",
      title: formatMessage({ id: "popup.createKnowledge.fromWebsite.title" }),
      description: formatMessage({
        id: "popup.createKnowledge.fromWebsite.description",
      }),
      inputTitle: "Public URL",
      inputPlaceholder: "e.g. http://example.org ",
    },
    GitBook: {
      api: "gitbook",
      title: formatMessage({ id: "popup.createKnowledge.fromGitbook.title" }),
      description: formatMessage({
        id: "knowledgeBase.popup.importFromGitBook.description",
      }),
      inputTitle: formatMessage({ id: "knowledgeBase.form.gitbookUrl.label" }),
      inputPlaceholder: formatMessage({
        id: "knowledgeBase.form.gitbookUrl.placeholder",
      }),
    },
  };

  const { title, description, inputTitle, inputPlaceholder } =
    linkWording[type];

  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState("");
  async function handleConfirm() {
    try {
      setLoading(true);
      const apiType = linkWording[type].api;

      await axios.post(`${apiUrl}/api/knowledgeBase/${apiType}`, {
        entityName,
        name: inputValue,
        sourceUrl: inputValue,
      });
      refetch();
      onClose();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Popup
      open={true}
      onClose={onClose}
      title={
        <Box className="item-flex">
          <img
            src={require("assets/img/ic_arrow_left.svg").default}
            onClick={onBack}
            style={{ cursor: "pointer", color: "#555", marginRight: "4px" }}
            width={24}
            height={24}
          />
          {title}
        </Box>
      }
      size="md"
      showFooter={true}
      onCancel={onClose}
      onConfirm={handleConfirm}
      confirmText="Add"
      confirmProps={{ disabled: inputValue.trim() === "" || loading }}
    >
      <Box display="flex" flexDirection="column" gap="24px 0">
        <Box color="#777">{description}</Box>
        <InputField
          isRequired
          title={inputTitle}
          type="text"
          placeholder={inputPlaceholder}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </Box>
    </Popup>
  );
}
